import axios from 'axios'
import { Message } from 'element-ui'
// 用于处理一次性并发多个接口的情况
const stackList = []
// let loadingInstance
let now = new Date()

// create an axios instance
const service = axios.create({
  baseURL: '/', // url = base url + request url
  // baseURL: '/base', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  headers: {
    'Ts': now.getTime(),
    'Content-Type': 'application/json;charset=UTF-8',
  },
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  async config => {
    let obj = {
      Platform: config.headers.Platform,
      Ts: config.headers.Ts
    }
    if (config.method != 'post') {
      for (let key in config.params) {
        obj[key] = config.params[key]
      }
    }
    if (config && config.showLoading) {
      stackList.push('flag')
      if (stackList.length === 1) {
        console.log();
        // window.gvm.$requestLoading.show()
        // loadingInstance = Loading.service({ fullscreen: true, customClass: 'global-loading' })
      }
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config && response.config.showLoading) {
      stackList.shift()
      if (stackList.length === 0) {
        console.log();
        // loadingInstance.close()
      }
    }
    const res = response.data
    if (res.code !== '1' && res.code !== '0') {
      return response
    }
    if (res.code !== '1') {
      if (res.msg) {
        if (document.getElementsByClassName('el-message').length === 0) {
          Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (error.response.config && error.response.config.showLoading) {
      stackList.shift()
      if (stackList.length === 0) {
        console.log();
        // loadingInstance.close()
      }
    }
    if (error.response && error.response.data) {
      if (error.response.data.msg) {
        if (error.response.data.msg === '无效的令牌') {
          if (document.getElementsByClassName('el-message').length === 0) {
            Message({
              message: error.response.data.msg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        } else {
          Message({
            message: error.response.data.msg,
            type: 'error',
            duration: 5 * 1000
          })
        }
        if (error.response.data.msg === '无效的令牌') {
          console.log('无效的令牌');
        }
      } else {
        Message({
          message: '服务器异常，请联系管理员(status:' + error.response.status + ',' + error.response.statusText + ')',
          type: 'error',
          duration: 5 * 1000
        })
      }
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
